import styles from "./UserGuideList.module.scss";

import React from "react";
import SectionWrapper from "./SectionPage/components/Section/SectionWrapper";
import SectionWrapperText from "./SectionPage/components/Section/SectionWrapperText";
import { Image } from "./SectionPage/components/Section/Section";
import { SectionPageContainerWrapper } from "./SectionPage/SectionPage";
import UserGuideStep from "../CmsComponents/UserGuideStep/UserGuideStep";
import SectionPageContext from "./SectionPage/SectionPageContext";
import CardSection from "./SectionPage/components/CardSection/CardSection";
import RichText from "../CmsComponents/RichText/RichText";

interface UserGuideHeading {
  title: string;
  description: string;
}

interface UserGuideStep {
  description: string;
  imageDesktop: Image;
  imageMobile: Image;
}
interface UserGuideLabels {
  makeBigger: string;
  otherPagesHeading: string;
  otherPagesReadMore: string;
}

interface OtherPage {
  name: string;
  url: string;
}

interface UserGuidePage {
  heading: UserGuideHeading;
  steps: UserGuideStep[];
  otherPages: OtherPage[];
  labels: UserGuideLabels;
}

interface Props {
  cmsContent: UserGuidePage;
}
const UserGuideSectionWrapperText = ({ children }) => (
  <SectionWrapperText
    sxTextSectionContainer={{
      ["@media screen and (min-width: 60rem)"]: {
        px: 2,
      },
    }}
  >
    {children}
  </SectionWrapperText>
);

const UserGuideList: React.FC<Props> = (props) => {
  const { cmsContent } = props;
  const { heading, steps, labels, otherPages } = cmsContent;
  return (
    <SectionPageContext.Provider
      value={{
        textSectionContainerMaxWidthOverride: "none",
        textSectionContainerMaxWidthOverrideMobile: "none",
      }}
    >
      <SectionPageContainerWrapper>
        <SectionWrapper anchorId={`intro`} backgroundColor={"bodyGray"} noImage={true}>
          <UserGuideSectionWrapperText>
            <h1 className={styles.heading}>{heading.title}</h1>
            {heading.description && <RichText html={heading.description} />}
          </UserGuideSectionWrapperText>
        </SectionWrapper>
        {steps.map((step, index) => {
          return (
            <SectionWrapper anchorId={`step-${index}`} key={`step-${index}`} backgroundColor={"white"} noImage={true}>
              <UserGuideSectionWrapperText>
                <UserGuideStep
                  counter={index + 1}
                  content={{
                    text: step.description,
                    desktopImage: step.imageDesktop,
                    mobileImage: step.imageMobile,
                    makeBiggerLabel: labels.makeBigger,
                  }}
                />
              </UserGuideSectionWrapperText>
            </SectionWrapper>
          );
        })}
        {otherPages.length > 0 && (
          <CardSection
            cardType="carousel"
            title={labels.otherPagesHeading}
            list={otherPages.map((otherPage) => ({
              title: otherPage.name,
              text: "",
              linkText: labels.otherPagesReadMore,
              href: otherPage.url,
              linkOnImageAndTitleHref: otherPage.url,
              linkOnImageAndTitleIsSpa: true,
              isSpa: true,
            }))}
          />
        )}
      </SectionPageContainerWrapper>
    </SectionPageContext.Provider>
  );
};

export default UserGuideList;
